<se-count-avatar
  *ngIf="showCount"
  se-data-size="{{ size }}"
  [se-data-border]="border"
  [se-data-count]="avatarsNotShown"
  [ngClass]="componentClass"
></se-count-avatar>
<se-common-avatar *ngFor="let a of shownAvatars"
  [se-data-type]="type"
  [se-data-size]="size"
  [se-data-identity]="a.identity"
  [se-data-image-url]="a.imgUrl"
  [se-data-border]="border"
  [se-data-sport]="a.sport"
  [se-data-team-color]="a.teamColor"
  [ngClass]="componentClass"
  [attr.aria-label]="'a.identity'"
  [se-data-status-icon]="a.statusIcon"
  [se-data-status-color]="a.statusColor"
></se-common-avatar>
